// URL search params for feed routes, validated so a hand-typed URL can't put the board in an
// impossible state.
import { BOARD_TABS, type BoardTab } from "./selectors";

export interface FeedSearch {
  tab?: BoardTab | undefined;
}

export function parseFeedSearch(raw: Record<string, unknown>): FeedSearch {
  const tab = raw.tab;
  return typeof tab === "string" &&
    (BOARD_TABS as readonly string[]).includes(tab) &&
    tab !== "review"
    ? { tab: tab as BoardTab }
    : {};
}

export interface AuditSearch {
  card?: string | undefined;
}

export function parseAuditSearch(raw: Record<string, unknown>): AuditSearch {
  return typeof raw.card === "string" && raw.card.trim() ? { card: raw.card.trim() } : {};
}
